import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { MerchantTypeForm } from "./Main";
import { useGetMerchantTypeQuery } from "../../features/api";
import { MerchantType } from "../../features/api-interfaces";

export const Update = () => {
  // 加盟店種別情報取得API呼び出し
  const { no } = useParams();
  const merchantTypeNo = no as string;
  let { data, refetch } = useGetMerchantTypeQuery(Number(merchantTypeNo));
  const registeredData = data as MerchantType;

  useEffect(() => {
    refetch();
  }, [refetch]);

  return <MerchantTypeForm registeredData={registeredData} refetch={refetch} />;
};
